import Modal from "components/foundation/Modal/Modal";
import styled, { css } from "styled-components";

export const FindPasswordFormStyle = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FindPasswordFormActions = styled.div`
  display: flex;
`;

export const FindPasswordModalStyle = styled(Modal.Body)`
  ${({ theme }) => css`
    ${theme.media.notSmall} {
      width: 38rem;
    }
  `}

  ${Modal.Title} {
    word-break: unset;
  }
`;
